export default {
  computed: {
    shouldShowMira() {
      const user = this.$store.getters['session/currentUser'];
      const enabled = this.$store.getters['aiEvents/miraEnabled'];
      const visible = this.$store.getters['aiEvents/miraVisible'];

      if (user && user.previewer) {
        return enabled;
      }
      return enabled && visible;
    },
  },
};
